import React from 'react';
import { Link } from 'react-router-dom';

const socials = [
  {
    name: 'LinkedIn',
    href: 'https://linkedin.com/company/esgcert',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="20" height="20" rx="4" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M7 10v7M7 7v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M11 17v-4c0-1.5 1-2 2-2s2 .5 2 2v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M11 10v7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    name: 'Twitter / X',
    href: 'https://twitter.com/esgcert',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4l16 16M4 20L20 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    name: 'Instagram',
    href: 'https://instagram.com/esgcert',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="20" height="20" rx="6" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor"/>
      </svg>
    ),
  },
  {
    name: 'YouTube',
    href: 'https://youtube.com/@esgcert',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="5" width="20" height="14" rx="4" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M10 9l5 3-5 3V9z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      </svg>
    ),
  },
];

const links = [
  { label: 'Home', to: '/' },
  { label: 'Vantaggi ESG', to: '/vantaggi' },
  { label: 'Chi siamo', to: '/chi-siamo' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contatti', to: '/contatti' },
];

export default function Footer() {
  return (
    /* Footer */
    <footer style={{ background: '#111714', padding: '24px', textAlign: 'center' }}>
        <style>{`
        .footer-link {
          font-size: 13px;
          color: rgba(255,255,255,0.5);
          text-decoration: none;
          transition: color 0.15s;
        }
        .footer-link:hover { color: rgba(255,255,255,0.9); }
        .social-btn {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          border: 1px solid rgba(255,255,255,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(255,255,255,0.5);
          text-decoration: none;
          transition: border-color 0.15s, color 0.15s, background 0.15s;
        }
        .social-btn:hover {
          border-color: #1D9E75;
          color: #1D9E75;
          background: rgba(29,158,117,0.08);
        }
      `}</style>

      {/* Main footer */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '48px 24px 32px', display: 'grid', gridTemplateColumns: '1fr auto', gap: 40, alignItems: 'start' }}>

        {/* Left: logo + tagline */}
        <div>
          <Link to="/">
            <img src="/Logo_or.png" alt="ESGcert" style={{ height: 55, marginBottom: 12, filter: 'brightness(0) invert(1)', opacity: 0.85 }} />
          </Link>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', lineHeight: 1.7, maxWidth: 280, margin: '0 0 20px' }}>
            Piattaforma di certificazione ESG per software. Basato su ISO 42001.
          </p>
          {/* Social icons */}
          <div style={{ display: 'flex', gap: 8 }}>
            {socials.map(s => (
              <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" className="social-btn" title={s.name}>
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Right: nav links */}
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.3)', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 14 }}>
            Navigazione
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {links.map(l => (
              <Link key={l.to} to={l.to} className="footer-link">{l.label}</Link>
            ))}
          </div>
        </div>

      </div>

      {/* Bottom bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 24, flexWrap: 'wrap' }}>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.25)', margin: 0 }}>
          © {new Date().getFullYear()} ESGcert — Tutti i diritti riservati
        </p>
        <div style={{ display: 'flex', gap: 16 }}>
          <a href="/privacy" className="footer-link" style={{ fontSize: 12 }}>Privacy Policy</a>
          <a href="/termini" className="footer-link" style={{ fontSize: 12 }}>Termini di servizio</a>
        </div>
      </div>
    </footer>
  );
}